import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouteLink } from 'react-router-dom';
import { navLinks, galleryNav } from './data/navigation';
import { site } from './data/site';
import ThemeToggle from './ThemeToggle';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const reduced = usePrefersReducedMotion();

  return (
    <nav className="navbar navbar-expand-lg sticky-top site-nav" aria-label="Primary">
      <div className="container-fluid nav-inner">
        <a className="brand" href="/" aria-label={`${site.brand} home`}>
          <img
            className="brand-logo brand-logo-on-dark"
            src="/images/logos/GKhub-logo-light-art.png"
            alt={site.brand}
          />
          <img
            className="brand-logo brand-logo-on-light"
            src="/images/logos/GKhub-logo-dark-art.png"
            alt=""
          />
        </a>
        <div className="nav-actions order-lg-last">
          <ThemeToggle />
          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={open}
            aria-label="Toggle navigation"
            onClick={() => setOpen((value) => !value)}
          >
            <FontAwesomeIcon icon={open ? faXmark : faBars} aria-hidden="true" />
          </button>
        </div>
        <div className={`navbar-collapse collapse${open ? ' show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-lg-auto">
            {navLinks.map(({ to, label }) => (
              <li className="nav-item" key={to}>
                <ScrollLink
                  to={to}
                  href={`#${to}`}
                  smooth={!reduced}
                  offset={-64}
                  duration={120}
                  spy={true}
                  className="nav-link"
                  activeClass="active"
                  onClick={() => setOpen(false)}
                >
                  {label}
                </ScrollLink>
              </li>
            ))}
            {/* The gallery is a separate route, not an in-page section, so it is a
                real router link rather than a scroll target. The arrow glyph marks
                it as leaving the page. */}
            <li className="nav-sep" aria-hidden="true" />
            <li className="nav-item">
              <RouteLink
                to={galleryNav.to}
                className="nav-link nav-link-page"
                onClick={() => setOpen(false)}
              >
                {galleryNav.label}
                <span className="nav-ext" aria-hidden="true">
                  {' '}
                  {'\u2197'}
                </span>
              </RouteLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
